var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topbar-wrapper"},[_c('div',{staticClass:"topbar"},[(!_vm.hideBackBtn)?_c('span',{staticClass:"back",on:{"click":_vm.back}}):_vm._e(),_vm._v("\n\n\t\t"+_vm._s(_vm.text)+"\n\n\t")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e4ac73","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/topbar.vue
// module id = null
// module chunks = 